module.exports = __webpack_public_path__ + "assets/gift.b435be85.svg";